import { useEffect, useRef } from 'react';
import ENDPOINTS from '../../config/apiUrls';
import { fetchCurrentUserProfile } from '../../store/slices/authSlice';
import { useDispatch } from 'react-redux';
import { getToken } from '../../helpers/utils';

const TwitterPopup = ({ 
  isOpen, 
  onClose, 
  onSuccess, 
  jwt 
}) => {
  const intervalRef = useRef(null);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!isOpen) return;

    // Create popup window
    const popupOptions = {
      toolbar: 'no',
      location: 'no',
      directories: 'no',
      status: 'no',
      menubar: 'no',
      scrollbars: 'yes',
      resizable: 'yes',
      width: 500,
      height: 400,
      top: (window.innerHeight - 400) / 2 + window.screenY,
      left: (window.innerWidth - 500) / 2 + window.screenX,
    };

    const optionsString = Object.entries(popupOptions)
      .map(([key, value]) => `${key}=${value}`)
      .join(',');

    const popupUrl = `${ENDPOINTS.SOCIAL.TWITTER_OAUTH}?jwt=${jwt}`;
    const popup = window.open(popupUrl, 'Twitter OAuth', optionsString);

    // Check if popup is closed
    const checkClosed = async () => {
      if (popup.closed) {
       let response =await dispatch(fetchCurrentUserProfile(getToken())).unwrap();
       console.log(response,'response')
        clearInterval(intervalRef.current);
        onClose();
      }
    };

    intervalRef.current = setInterval(checkClosed, 100);

    // Listen for messages from popup
    const handleMessage = (event) => {
      // Verify origin for security
      if (event.origin !== process.env.REACT_APP_API_BASE_URL) {
        return;
      }

      const data = event.data;
      if (data && typeof data === 'object') {
        if (data.completed && data.twitter) {
          // Twitter connection successful
          console.log(data.twitter);
          
          onSuccess(data.twitter);
          popup.close();
          clearInterval(intervalRef.current);
          onClose();
        } else if (data.error) {
          // Handle error
          console.error('Twitter connection error:', data.error);
          popup.close();
          clearInterval(intervalRef.current);
          onClose();
        }
      }
    };

    window.addEventListener('message', handleMessage);

    // Cleanup function
    return () => {
      clearInterval(intervalRef.current);
      window.removeEventListener('message', handleMessage);
      if (popup && !popup.closed) {
        popup.close();
      }
    };
  }, [isOpen, jwt, onClose, onSuccess]);

  // Don't render anything visible
  return null;
};

export default TwitterPopup;
